import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user:null,
  token:null,
  loaded:false,
  plan:null,
  p_and_l:0,
  unread_notification:0,
  switchableAccounts: [],
  activeAccountId: null,
  isAdmin: false,
}

export const userSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    set_user: (state,action) => {
      state.loaded=true;
        state.user=action.payload;
    },
    set_plan:(state,action) => {
      state.plan=action.payload;
    },
    set_token: (state,action) => {
      state.token=action.payload;
    },
    set_p_and_l:(state,action)=>{
      state.p_and_l=action.payload;
    },
    set_unread_notification:(state,action)=>{
      state.unread_notification=action.payload;
    },
    set_account_context:(state, action) => {
      state.switchableAccounts = action.payload.switchableAccounts || [];
      state.activeAccountId = action.payload.activeAccountId || state.user?._id || null;
      if (typeof action.payload.isAdmin === 'boolean') {
        state.isAdmin = action.payload.isAdmin;
      }
    },
  },
})

// Action creators are generated for each case reducer function
export const { set_token,set_user,set_plan,set_p_and_l,set_unread_notification,set_account_context } = userSlice.actions

export default userSlice.reducer